export const oneWord = str => {
  return str && typeof str === 'string' ? str.replace(/\s+/g, '') : null;
};
